import React from 'react'

const ProfileGrid = props => (
  <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-4 lg:gap-x-14" {...props} />
)

export default ProfileGrid
